import { Dispatch, ReactNode, SetStateAction } from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-router-dom';
import edit from '../../../../../assets/images/icons/edit.svg';
import maps from '../../../../../assets/images/icons/maps.svg';
import shapePost from '../../../../../assets/images/icons/shapePost.svg';
import trash from '../../../../../assets/images/icons/trash.svg';
import {
  Card,
} from '../../../../../components/Lists';
import OpacityAnimation from '../../../../../components/OpacityAnimation';
import useGetGeneralAppData from '../../../../../hooks/useGetGeneralAppData';
import { LineBeingDeletedType, LineBeingPostedShapeType, LineMapBeingShowType, LineType } from '../../types';

interface ListInterface {
  filteredLines: LineType[];
  directionsTagLiterals: { [key: number]: ReactNode };
  setLineMapBeingShow: Dispatch<SetStateAction<LineMapBeingShowType>>;
  setLineBeingPostedShape: Dispatch<SetStateAction<LineBeingPostedShapeType>>;
  setLineBeingDeleted: Dispatch<SetStateAction<LineBeingDeletedType>>;
  setModalDeleteShow: Dispatch<SetStateAction<boolean>>;
}

export default function List({
  filteredLines,
  directionsTagLiterals,
  setLineMapBeingShow,
  setLineBeingPostedShape,
  setLineBeingDeleted,
  setModalDeleteShow,
}: ListInterface) {
  const { isCustomer, permissions } = useGetGeneralAppData();
  const affreightmentsLinesPermissions = permissions.find((x) => x.codPag === 10);

  return (
    <Container>
      <Row xs={1} md={1} lg={2}>
        {filteredLines?.map((line) => (
          <Col key={line.lineId}>
            <OpacityAnimation delay={0.1}>
              <Card>
                <div className="info">
                  <div className="card-title">
                    <strong>{line.lineCode}</strong>
                    {!!line.direction && (
                      directionsTagLiterals[line.direction]
                    )}
                  </div>
                  <span>{line.lineSign.replace('.kml', '')}</span>
                  <span>
                    {line.departureTime}
                    {' '}
                    -
                    {' '}
                    {line.arrivalTime}
                  </span>
                  <span>
                    {line.capacity}
                    {' '}
                    lugares
                  </span>
                  <span>{line.workplaceDescription}</span>
                </div>

                <div className="actions">
                  {line.hasKmlFile && (
                    <Link
                      to="/lines/map"
                      onClick={() => {
                        setLineMapBeingShow({
                          routeId: line.routeId,
                          lineCode: line.lineCode,
                          lineSign: line.lineSign,
                        });
                      }}
                    >
                      <img src={maps} alt="maps" title="Mapa da line com passageiros" />
                    </Link>
                  )}

                  {!isCustomer && (
                    <>
                      {(affreightmentsLinesPermissions?.alterar || affreightmentsLinesPermissions?.incluir) && (
                        <Link
                          to="/lines/shape"
                          onClick={() => {
                            setLineBeingPostedShape({
                              routeId: line.routeId,
                              lineCode: line.lineCode,
                              lineSign: line.lineSign,
                            });
                          }}
                        >
                          <img src={shapePost} alt="shapePost" title="Vincular KML à linha" />
                        </Link>
                      )}

                      {affreightmentsLinesPermissions?.alterar && (
                        <Link to={`/lines/edit/${line.lineId}`}>
                          <img src={edit} alt="edit" title="Editar linha" className='primaryColor' />
                        </Link>
                      )}

                      {affreightmentsLinesPermissions?.excluir && (
                        <button
                          type='button'
                          onClick={() => {
                            setLineBeingDeleted({
                              routeId: line.routeId,
                              lineId: line.lineId,
                              lineCode: line.lineCode,
                              direction: line.direction,
                              lineSign: line.lineSign,
                              departureTime: line.departureTime,
                              arrivalTime: line.arrivalTime,
                              capacity: line.capacity,
                              workplaceDescription: line.workplaceDescription,
                            });
                            setModalDeleteShow(true);
                          }}
                        >
                          <img src={trash} alt="trash" title="Excluir line" />
                        </button>
                      )}
                    </>
                  )}
                </div>

              </Card>
            </OpacityAnimation>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
